import { IConfigEntry } from './model/IConfigEntry';
import { getAll } from './Provider';

const RESOURCE = 'configuration';

export const Configuration = {
  getAll: () => getAll<IConfigEntry>(RESOURCE)
}